import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>プライバシーポリシー</h2>
                <h2>Dreamehomeプライバシーポリシー</h2>
                <h3><strong>前書き</strong></h3>
                <p>『Dreamehome』事業はDreame Innovation Technology (Suzhou) Co., Ltd. 及びその関連会社
                    （以下は「当社」または「Dreame」と略称）が運営し、インテリジェントなハードウェア機器の制御と管理サービスを提供するプラットフォーム（またはサービス）です。当社はあ客様にとっての個人情報の重要性を理解しており、お客様の個人情報を保護するために最善を尽くします。当社は業界認定のセキュリティ基準に基づいて、お客様の個人情報を保護するための適切なセキュリティ対策を講じます。
                </p>
                <p>したがって、当社の製品(またはサービス)をご利用になる前に、『Dreamehomeプライバシーポリシー』の内容をよく読んで理解してください。</p>
                <p>未成年者の方は、保護者の同意を得たうえで本アプリを使用し、関連するアプリ利用規約に同意してください。</p>
                <p>
                    本プライバシーポリシーはお客様のニーズを十分に考慮したうえで定められたものであり、当社の個人情報の収集および使用方法を完全に理解できると同時に、提供される個人情報を最終的にお客様が管理できるような状況を確保し、これは非常に重　要な点となります。
                </p>
                <p>本プライバシーポリシーには、アプリ使用時に当社に提供される情報の収集・使用・開示・処理・保存方法が規定されており、当社はこれらの情報を使用するうえで本プライバシーポリシーを厳守します。</p>
                <p>本プライバシーポリシーには、以下の内容が記載されています。</p>
                <p>１．収集する情報とその使用方法について</p>
                <p>２．Cookieおよび類似技術の使用方法について</p>
                <p>３．個人情報の委託対応・共有・転送・公開について</p>
                <p>４．個人情報の保存および保護について</p>
                <p>５．お客様の権利について</p>
                <p>６．国境を越えたデータ転送について</p>
                <p>７．当社へのお問い合わせについて</p>
                <p>８．プライバシーポリシーの更新について</p>
                <p>添付リスト1：サードパーティーSDK詳細</p>
                <p>
                    最後に、当社はお客様に最高のユーザーエクスペリエンスをお届けすることを目的としており、当社には専門のプライバシー対応部門と担当者が準備されておりますので、本プライバシーポリシーに関するご不明な点などがありましたら、本プライバシーポリシー内「(7)
                    当社へのお問い合わせについて」から当社までご連絡ください。当社は各国のポリシー、法律により規定されている期限にもとづいてお返事いたします。当社の対応にご満足いただけない場合、特に当社の個人情報取り扱い方法により、お客様の正当な権利や利益が害された場合、お客様は管轄内の人民法院で訴訟を起こす、または政府の規制機関にクレームを入れるなどの方法により問題を解決することができます。
                </p>
                <h3><strong>収集する情報とその使用方法について</strong></h3>
                <p>個人情報とは、電子的または他の方法により記録されており、情報そのものまたは関連情報から個人を特定することが可能な各種データを指します。</p>
                <p>
                    個人機密情報とは、漏洩や違法な提供または悪用により、人体および財産の安全を危険にさらし、個人の名誉や健康状態の損害、または差別的な扱いにつながる可能性のある個人情報(身分証明書情報/個人の生体識別情報/銀行口座番号/財産情報/所在情報/取引情報/14歳以下の児童の個人情報などを含むが、これらに限定されるものではありません)を指します。
                </p>
                <p>当社はお客様に製品とサービスの両方、またはいずれかを提供し、かつ適用される法律・規定およびその他の規範的な文章を確実に厳守することを主な目的としてお客様の個人情報を収集しております。</p>
                <p>
                    なお、当社に個人情報を提供するかどうかはお客様側で決定することができますが、個人情報が提供されなかった場合、基本的に対応するサービスをご提供することができず、同様にお客様側で生じた問題への対応も致しかねますので、予めご了承ください。
                </p>
                <h4>Dreamehomeの基本サービスにおける個人情報の収集および使用形式</h4>
                <h4>Dreamehomeのスマートハードウェアデバイスとの接続および管理</h4>
                <p>
                    Dreamehomeのサービスを提供するにあたり、スマートハードウェアデバイスと安全に接続したうえで管理するために、当社はお客様のWi-Fi情報・位置情報・ログインアカウント情報・スマートフォン関連の情報・スマートハードウェアデバイス関連の情報・Dreameアカウントとスマートハードウェアデバイスとの関連付け情報を取得する場合があります。なお、これらの情報はスマートハードウェアデバイスとのクイック接続・接続・付近のデバイスの検出・デバイス管理機能をお客様に提供するために使用されます。
                </p>
                <p>上述の各項目の詳細情報は以下の通りです。</p>
                <p>
                    ログインアカウント情報：Dreameアカウント名・パスワード・ニックネーム・アイコン画像・Eメールアドレス・携帯電話番号が含まれます。その内、<strong>アカウント名・パスワード・携帯電話番号・Eメールアドレス</strong>は個人機密情報に属します。これらの情報は、Dreameアカウントサーバーにログインしてお客様の身元を確認し、Dreamehomeアカウントのサーバーアクセス権限を取得することを目的として収集されます。お客様により入力されたアカウント名とログインパスワードの認証情報は、暗号化されてDreameアカウントサーバーに転送され、ログイン認証が実行されます。
                </p>
                <p>スマートフォン関連情報：ハードウェアデバイスID(IMEI/OAID、Macアドレス、Android
                    ID)・スマートフィン型番・システムVer情報・システム言語・スマートフォンが設定されている国/エリア・画面サイズおよび解像度・CPUおよびディスプレイデバイス関連情報を含みます。これらの情報はDreamehomeアプリとスマートハードウェアデバイスとの接続を目的として収集されます。
                </p>
                <p>
                    スマートハードウェアデバイス情報：スマートハードウェアデバイスの名称・型番・Ver・生産メーカー・デバイスシリアルナンバー・Macアドレス・IPアドレス・デバイス動作ステータス・カスタムプロパティ・設定パラメータ・ビジネスイベント・デバイス制御および使用記録を含みます。これらの情報は、スマートハードウェアデバイスとバインドし、デバイスの制御や管理、およびデバイスプロパティやパラメータの設定、デバイス動作ステータスや使用記録を確認するために収集されます。
                </p>
                <h4>Dreamehomeアプリおよびスマートハードウェアデバイスのアップグレード</h4>
                <p>
                    最新のDreamehomeアプリサービスをご利用いただくにあたり、お客様にDreamehomeアプリのアップグレードサービスを提供するために、お客様のDreamehomeアプリのVer・スマートフォン型番情報を使用する場合があります。<br />また、お客様に最新Verのサービス(ファームウェアVer含む)をご利用いただくにあたり、スマートハードウェアデバイスのアップググレード機能を提供するために、接続済みのスマートハードウェアデバイスのリスト・Ver情報を収集する可能性があります。<br />なお、Dreamehomeアプリはスマートハードウェアデバイスのアップグレードパスのみを提供し、スマートハードウェアデバイスのファームウェアVerは生産メーカーにより提供され、Ver品質やアップグレード結果については生産メーカーが責任を負うものとします。<br />また、これらの情報が提供されなかった場合、Dreamehomeアプリおよびスマートハードウェアデバイスのファームウェアの最新Verへのアップグレードサービスは提供致しかねます。
                </p>
                <h4>オンライン上での問題フィードバック</h4>
                <p>
                    Dreamehomeアプリおよびスマートハードウェアデバイスで発生した問題を迅速に解決するために、オンライン上での問題フィードバック機能が用意されています。<br />本機能を使用するにあたり、Dreamehomeアプリおよびスマートハードウェアデバイのログ情報・お客様の連絡先と問題説明・問題発生時の画像や動画が必要となります。その内、アプリおよびデバイスのログ情報はデバイスステータス、センサーデバイスが感知した情報やデバイス制御ログ、デバイスシリアルナンバーなどの情報が含まれており、問題発生原因の特定および分析を行う際に使用されます。<br />お客様の連絡先は、お客様への連絡時や問題解決の有無の確認、追加で他のデータをご提供いただく際などに使用されます。<br />当社ではお客様からフィードバックされた問題の特定および解決時のみにお客様の個人情報を使用し、個人情報を開示したり、商業広告目的などの用途に使用することはありません。<br />これらの情報が提供されない場合、当社はお客様からフィードバックされた問題に対する有効的な特定や解決を行うことができません。
                </p>
                <h4>Dreamehomeの基本サービス提供以外での個人情報の収集および使用形式</h4>
                <p>
                    Dreamehomeは基本サービス以外にも、以下の付加価値機能においてお客様の個人情報を収集および使用する場合があります。<br />これらの個人情報が提供されなかった場合においても、Dreamehomeの基本サービスはご利用いただけますが、以下のようなユーザーエクスペリエンスを向上させるための付加価値機能をご利用いただけない場合があります。
                </p>
                <h4>ユーザーエクスペリエンス改善プラン</h4>
                <p>
                    ユーザーエクスペリエンスの改善にあたり、お客様のDreamehomeのログを収集する必要があります。本ログには暗号化済みのキーフローログ/イベントログ/故障ログ/ビジネスイベント/アプリ各UIの使用状況などが含まれていますが、お客様の機密情報は含まれていません。<br />なお、上述の情報は自動で収集されたうえでサーバーに転送され、ログ情報を分析してデバイス動作ステータスを診断したり、アプリの使用状況の分析が行われます。
                </p>
                <p>この情報を提供しない場合、Dreamhomeはタイムリーにユーザーエクスペリエンスを向上させることができませんが、これはサービスの基本機能に影響を与えません。</p>
                <h4>他社から個人情報を取得する形式</h4>
                <p>
                    以下のような合法的な状況下において、当社は他社からお客様の個人情報を取得する場合があります。<br />お客様の同意を得ていることを前提とし、他社スマートハードウェアデバイスの管理業務内において、当社は他社のサービスプロバイダーと提携し、その過程において他社サービスプロバイダーからお客様の個人情報を取得する場合があります。<br />他社デバイスの管理業務内において、お客様が他社アカウントとのバインドを行っている状況下において、他社アカウントの情報(ニックネームやアイコン画像を含み、Dreamehomeアプリ上でこれらの情報を表示する際に使用)、およびデバイスとネットワーク情報(デバイスID・Macアドレス・デバイスシリアルナンバーが含まれており、現在動作しているデバイスの識別やデバイスを安全に制御するために使用)を取得する場合があります。<br />当社の業務展開時における個人情報の取り扱い方法が、お客様が他社サービスプロバイダーに個人情報を提供する際に許可した範囲を超えている場合、お客様の明確な同意をえたうえで、お客様の個人情報を取り扱うものとします。<br />これら以外にも、当社は法規制を厳格に遵守し、他社サービスプロバイダーから提供される情報の合法性を要求するものとします。
                </p>
                <h4>非個人情報</h4>
                <p>
                    上述の情報項目以外に、お客様に提供するサービスの改善を目的として、当社はお客様が特定のサービスを使用した際の統計データや、お客様の操作アクション(タップ/画面移動/閲覧時間などを含む)などの個人特定に影響を及ぼさない情報(すなわち個人情報に属さない情報)を収集する場合があります。<br />収集される情報の種類や量は、お客様の当社製品またはサービスの使用状況により異なります。<br />当社では、これらの情報を集約することにより、お客様により有益な情報を提供、およびお客様が当社Webサイト/製品/サービスのどの部分に興味をいただいているのかを分析し、当社サービスUIの最適化を行う際に使用します。<br />なお、本プライバシーポリシーにおいて、これらの集約データは非個人情報に属します。非個人情報と個人情報を組み合わせて使用する場合、その期間中においてこれらの情報が個人情報として扱われます。
                </p>
                <h3><strong>Cookieおよび類似技術の使用方法について</strong></h3>
                <p>
                    Dreamehomeの正常動作を確保するため、当社ではお客様のデバイス上にCookieという名称のデータファイルを保存します。Cookieには通常、識別子やWebサイト名、いくつかの番号や文字が含まれており、DreamehomeはCookieによりログインアカウントやプリファレンスなどのデータを保存します。<br />当社では、Cookieを本声明で挙げられている目的以外のいかなる用途で使用することはありません。Cookieはお客様自身で管理や削除することができますが、そうした場合、一部の状況下においてDreamehomeに安全にアクセスすることができなくなってしまう恐れがあり、さらにDreamehomeにアクセスするたびにお客様自身でユーザー設定を変更する必要性が生じる場合があります。
                </p>
                <h3><strong>個人情報の委託対応・共有・譲渡・開示について</strong></h3>
                <h4>委託対応</h4>
                <p>
                    通常、当社は他社にお客様の個人情報の取り扱いを委託する場合があります。例として、当社に代わってお客様に連絡したり、Eメールを送信、およびテクニカルサポートを提供する会社が挙げられ、これらの会社は当社に代わってお客様にサービスを提供すつ場合にのみ、お客様の個人情報を使用します。<br />当社は委託業者との間で厳格な機密保持契約および個人情報取り扱い条項に署名しており、委託業者が本プライバシーポリシーに従って個人情報を取り扱い、関連する機密保持並びにセキュリティ保護対策を講じることを義務付けています。
                </p>
                <h4>共有</h4>
                <p>以下の状況を除き、通常の状況において、当社が外部にお客様の個人情報を共有することはありません。</p>
                <ol>
                    <li>
                        お客様の明確の同意を得た後、お客様が許可した範囲内の情報をお客様が指定した第三者に共有します。<br />これには、お客様の要求に応じて、スマートホーム製品の情報や設定などをお客様の親戚や友人に共有することも含まれており、親戚や友人は端末デバイスを介して本ソフトウェアおよびサービスを使用できます。
                    </li>
                    <li>
                        Dreamehomeのサービス内容の一部(Webサイトのホスティング/デーや分析/支払いややクレジットカード情報の処理/インフラ施設の供給/ITサービス/カスタマーサポートサービス/Eメール送信サービス/その他類似サービスを含む)は他社のサービスプロバイダーから提供されているため、当社はサービスプロバイダーにお客様の個人情報の一部を提供する必要があります。
                    </li>
                    <li>
                        当社のウェブサイトおよびサービスへのアクセスおよび使用に使用するスマートハードウェアデバイスおよび/またはネットワークおよびシステムを直接的または間接的に提供する顧客およびその他のビジネスパートナーにお客様の個人情報を開示する場合があります
                    </li>
                    <li>
                        当社のすべてまたは一部の業務、資産、株式の再編、合併、売却、合弁、譲渡、もしくはその他処置が生じた場合(破産や類似する手続きに関連する上述の状況含むがこれらに限定されるものではない)、関連会社やその他第三者にお客様の個人情報を開示する場合があります。<br />このような状況下において、お客様はEメールおよび/または当社Webサイトを通じて所有権の変更、個人情報の新しい使用方法の非互換性、および個人情報の選択に関する明確な通知を受取ります。
                    </li>
                    <li>
                        当社が必要または適切であると判断した場合、以下を執行します。<br />(a)適用される法規制を遵守<br />(b)法的手続きを遵守<br />(c)公的機関および政府当局(お客様がお住まいの国/地域以外の公共機関および政府当局も含む)の要求に応答<br />(d)当社の規約および条件を執行<br />(e)当社の運営、業務およびシステムを保護<br />(f)当社および/またはお客様を含む他のユーザーの権利、プライバシー、安全または財産を保護<br />(g)利用可能な救済処置の追求、または当社が提供する必要性のある損害賠償の制限
                    </li>
                    <li>定期的に授業活動を展開するために、当社の子会社または関連会社にお客様の個人情報を開示する場合があります。</li>
                    <li>
                        当社はアプリケーション・プログラミング・インターフェース(API)やソフトウェア開発キット(SDK)を介して他社に必要なデータを共有する場合があります。<br />VerごとにサードパーティSDKに違いがありますが、通常はサードパーティアカウントログインタイプ、共有タイプ、サードパーティ支払いタイプ、ベンダープッシュタイプ、統計タイプなどが含まれており、当社は他社に対して厳格なセキュリティ保護対策およびデータ保護処置を講じることを義務づけています。<br />『添付リスト1』は、当社がアクセスを許可しているサードパーティSDKの詳細ですので、よくお読みください。<br />当社のプライバシーポリシーは、他社が提供する製品またはサービスには適用されませんので、お客様がこれらの製品またはサービスを使用する場合、お客様の情報を収集する場合があります。<br />したがって、当社のプライバシーポリシーをお読みいただくのと同様に、他社のプライバシーポリシーをよくお読みいただくことを強く推奨しております。<br />当社は他社がお客様から収集した個人情報の用途については責任を負わず、それらに対する管理を行えません。<br />当社のプライバシーポリシーは、当社のサービスを通じてリンクされている他社のWebサイトには適用されないため、お客様はリンク先のWebサイトとのやり取りを自身で判断する必要があります。<br />初めて他社のWebページにアクセスした際、他社サービスプロバイダーにより関連する契約およびプライバシーに関する声明が表示されますので、これらの内容をよくお読みください。
                    </li>
                </ol>
                <h4>譲渡</h4>
                <p>以下の状況を除き、当社がお客様の個人情報をいかなる会社、組織および個人に譲渡することはありません。</p>
                <ol>
                    <li>お客様からの明確な同意を得たうえで、当社は他社にお客様の個人情報を譲渡する場合があります。</li>
                    <li>
                        合併、買収または破産における清算時において、個人情報の譲渡が生じる場合、当社はお客様の情報を保持する新しい会社または組織に対して本声明の継続を要求します。<br />継続されない場合、当社はその会社または組織がお客様に対して再度同意を得るように要求します。
                    </li>
                </ol>
                <h4>開示</h4>
                <p>当社は以下のような状況下において、お客様の個人情報を開示する場合があります。</p>
                <ol>
                    <li>お客様の明確な同意を得たうえでの開示</li>
                    <li>法律にもとづく開示：当社は法律に準拠、または法的手続き、訴訟または政府当局にの義務的要求にもとづいて、お客様の個人情報を開示する場合があります。</li>
                </ol>
                <h3><strong>個人情報の保存および保護について</strong></h3>
                <p>
                    当社は、本プライバシーポリシーに記載されている情報収集に必要な期間、または適用される法的要件を遵守するうえで個人情報を保持します。<br />収集目的が完了した場合、または当社がお客様のからの削除やアカウント削除申請を受けた場合や、対応する製品またはサービスの運営が終了した場合、当社は保持を停止し削除、または匿名化処理を行います。
                </p>
                <p>公益、科学、歴史研究や統計を目的としている場合は、それ以上のデータ処理が元の収集目的と関係がない状況下においても、当社は適用する法律に準じて関連データを保持し続けます。</p>
                <p>Dreamehomeの業務において、お客様の個人情報の保存期間は以下のようになっています。</p>
                <p>お客様がDreamehomeアプリをアンインストール、またはDreamehomeアプリのデータを削除した場合、Dreamehomeアプリのローカルに保存されているすべてのデータが即座に削除されます。</p>
                <p>
                    お客様がスマートハードウェアデバイスを削除、またはDreamehomeのプライバシーポリシーに同意せず、Dreamehomeサービスの使用を停止した場合、サーバーに保存されているDreamehomeスマートハードウェアデバイスおよび業務データはすべて即座に削除されます。
                </p>
                <p>サーバーに保存されている業務ログ、統計データや使用記録は、当社が不定期でサーバー上から削除します。なお、通常これらのデータの保存期間が2年を超えることはありません。</p>
                <p>上述の内容以外に、当社の製品またはサービスの運営が終了した場合、お客様に対して通知・お知らせが行われたうえで、合理的な期間内でお客様の個人情報が削除、または匿名化処理が行われます。</p>
                <h3><strong>お客様の権利について</strong></h3>
                <h4>お客様の個人情報へのアクセス、変更、削除</h4>
                <p>
                    お客様に適用される国または地域の法規制に従い、お客様は当社が保持するお客様に関連性のある個人情報にアクセス、変更、削除を申請する権利(以下「申請」と省略)を有していますので、EメールまたはDreamehomeアプリから当社までご連絡ください。<br />大部分の法律では、個人情報主体による申請は特定の条件を遵守することが求められています。<br />本プライバシーポリシーでは、お客様からの申請が以下の状況に準拠していることが求められています。
                </p>
                <p>申請専用のルートを使用し、かつお客様の情報セキュリティの保護を考慮したうえで、書面での申請を行う(現地の法律で口頭での申請が明確に認められている場合を除く)。</p>
                <p>申請者が申請された情報の対象、または法的に許可された人物であることを確認できるように、当社にお客様の身分を確認するための十分な情報を提供する。</p>
                <p>お客様からの申請を承認するために必要な十分な情報を取得後、当社は適用されるデータ保護法に定められている期間内にお客様の申請を執行します。</p>
                <p>具体的には以下のようになっています。</p>
                <p>
                    お客様のご要望および適用される法規制にもとづき、当社は収集済みかつ処理済みのお客様に関する個人情報記録を無償で提供します。<br />お客様が関連情報に対して他の申請を行った場合、当社は適用される法律にもとづき、かつ実際の管理コストを踏まえたうえで、お客様に合理的な範囲内の費用を要求する場合があります。
                </p>
                <p>当社が保持しているお客様の情報に誤りや不完全な部分がある場合、使用目的に応じて個人情報の変更または追加を要求することができます。</p>
                <p>
                    適用される法規制にもとづき、お客様は当社に対して自身の個人データの削除を要求することができます。<br />当社はお客様からの削除申請に対して確認を行い、関連する条件を満たせていることが確認された場合、当社は対処するため技術的手段を含む対応処置を講じます。<br />お客様または当社が代わりにお客様の関連データを削除した後、適用される法律およびセキュリティ技術により、当社は対応する情報を即座にバックアップシステムないから削除することができない場合がありますが、当社はバックアップデータが削除されるまで、または匿名化が行われるまでの間、お客様の個人情報を安全に保存し、それ以上の処理が行われないように隔離します。<br />例として、《中華人民共和国電子商取引法》にもとづき、お客様の商品およびサービス情報、取引情報の保存期間は取引完了日から少なくとも3年間保持されます。
                </p>
                <p>
                    当社は実質的ではない申請や問題があるにもかかわらず繰り返される申請、他社のプライバシーを害する申請、極端に現実的ではない申請、つり合いが取れていない技術作業を伴う、および現地の法律にもとづき受諾する必要がない、すでに開示されている情報、機密保持に関連する情報の申請の処理を拒否する権限を有しています。<br />当社により、データ削除またはデータアクセスの申請が特定の側面において、上述の不正防止およびセキュリティ目的でデータを合法的に使用できない可能性があると判断された場合、当社はそれを拒否する場合があります。
                </p>
                <h4>同意の取消し</h4>
                <p>
                    お客様は要求を提出することにより、当社が把握または管理しているお客様の個人情報の収集、使用、開示に対する同意を取り消すことができます。ご利用のサービスに応じて、本プライバシーポリシーのセクション7に記載されている連絡先で当社にご連絡いただくことができます。当社は、お客様の要求から合理的な期間内にお客様の要求を処理し、お客様の要求に応じて、お客様の個人情報の収集、使用、開示を一切行わないものとします。
                </p>
                <p>
                    お客様が同意取消しを申請した場合、情報を処理する権限の範囲にもとづき、Dreamehomeまたはスマートハードウェア製品のサービスをご利用いただけなく場合がありますので、ご注意ください。なお、同意または承認の取消しの決定により、承認にもとづく以前の個人情報の処理に影響が生じることはありません。
                </p>
                <p>同意取消しを申請するか、Dreamehomeの画面で変更することでユーザーエクスペリエンス改善プランを終了し、個人情報の使用に対する同意を取消すことができます。</p>
                <h4>Dreamehomeアカウントの登録解除</h4>
                <p>
                    Dreamehomeアカウントを登録解除するには、「マイ」→「アカウントの設定」→「アカウントのログアウト」の手順に従ってアクセスしてください。Dreamehomeのアカウント登録を解除したい場合は、Dreamehomeのアカウントを登録解除すると、Dreamehomeとそのすべてのインテリジェントなハードウェア製品およびサービスを利用できなくなりますので、ご注意ください。当社は、お客様または他者の合法的な権利を保護するために、お客様のDreamehomeの各インテリジェントなハードウェア製品およびサービスの使用状況を考慮して、お客様の登録解除をサポートするかどうかを判断します。
                </p>
                <h3><strong>国境を越えたデータ転送について</strong></h3>
                <p>
                    当社は世界中のリソースやサーバーを通じて製品やサービスを提供しており、これはお客様からの承認と同意を得た後、お客様の個人情報がお客様が製品またはサービスを使用している国/地域の管轄外の区域に転送される、またはこれらの管轄区域からのアクセスを受けることがあることを意味しています。
                </p>
                <p>
                    お客様の情報が転送される可能性がある国/地域のデータ保護処置や法規制は、お客様がお住まいの国/地域と同様とは限りません。<br />このような状況下において、当社はお客様の個人情報を保護するために、各管轄区域に適用される法律にもとづいて、適切かつ合法的な処置を施しています。
                </p>
                <p>特別な説明：</p>
                <p>
                    お客様が欧州経済領域(EEA)にお住まいであり、お客様の個人情報がEEAの外部に転送される場合、弊社はEU委員会により十分なレベルの保護を提供できることが確認されている地域でお客様の個人情報を処理、またはEU委員会の標準契約条項などに該当する転送メカニズムに従った転送を含む、個人情報を保護するための適切な保護手段を講じます。
                </p>
                <h3><strong>当社へのお問い合わせについて</strong></h3>
                <p>
                    本プライバシーポリシーに関するご意見やご不明な点、または当社の個人情報取り扱いに問題などがありましたら、以下の連絡先、またはDreamehomeのXにアクセスして「プライバシーポリシー」と説明してください。<br />お客様の個人情報関連の権利要求、問題に関するお問い合わせなどに対して、当社の専門チームが対応いたします。<br />お客様からのお問い合わせ内容が重要な問題を含んでいる場合、当社はお客様に対して詳細な情報の提供を要求する場合があります。当社の回答に対してご満足いただけない場合、管轄区域の関連する監督機関にクレームを提出することができます。お客様からお問い合わせがあった場合、当社はお客様の実際の状況に応じて、クレーム提出先の情報を提供できる場合があります。
                </p>
                <p><strong>メールアドレス：</strong></p>
                <ul>
                    <li>中国担当連絡先： </li>
                    <li>シンガポールDPO連絡先：<a className="page"
                        href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a></li>
                    <li>EU代表連絡先：<a className="page"
                        href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a> </li>
                </ul>
                <p><strong>電話番号：</strong>400-875-9511</p>
                <p><strong>公式ホームページ：</strong><a className="page"
                    href="https://www.dreametech.com">https://www.dreametech.com</a></p>
                <h3><strong>プライバシーポリシーの更新について</strong></h3>
                <p>
                    当社は本プライバシーポリシーを適時に更新する権利を有しています。本ポリシーに変更が生じた場合、ポップアップ形式、またはその他の分かりやすい手段でお客様に変更の旨をお知らせします。<br />お客様の同意を得た場合にのみ、当社は更新後のポリシーにもとづいてお客様の個人情報の収集、使用および保存を行います。
                </p>
                <p>本ポリシーは更新日から有効となります。</p>
                <p>最終更新日：2021年8月28日</p>
                <h3><strong>添付リスト1：サードパーティSDKの詳細</strong></h3>
                <p>*お客様にさらに専門的、かつ安全な基礎および付加価値機能サービスをお届けするため、DreamehomeはサードパーティSDK製品にアクセスできます。</p>
                <p>現在Dreamehomeがアクセス可能なサードパーティSDK製品は以下の通りです。</p>
            <div className='tableStyle'>
                <table>
                    <tr>
                        <td>
                            <p><strong>SDKサービス</strong></p>
                        </td>
                        <td>
                            <p><strong>詳細機能</strong></p>
                        </td>
                        <td>
                            <p><strong>取得情報</strong></p>
                        </td>
                        <td>
                            <p><strong>対応するプライバシーポリシー</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng<br />統計分析SDK</p>
                        </td>
                        <td>
                            <p>統計・分析</p>
                        </td>
                        <td>
                            <p>デバイス識別子(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM カード IMSI 情報)、位置情報</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng <br />U-Push/Pro SDK</p>
                        </td>
                        <td>
                            <p>メッセージ送信</p>
                        </td>
                        <td>
                            <p>デバイス識別子(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM カード IMSI 情報)、位置情報</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng<br />U-Share SDK</p>
                        </td>
                        <td>
                            <p>他社への共有</p>
                        </td>
                        <td>
                            <p>デバイス識別子(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM カード IMSI 情報)、位置情報</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Agora SDK</p>
                        </td>
                        <td>
                            <p>マイク連動、ビデオストリーム再生</p>
                        </td>
                        <td>
                            <p>デバイス情報、インターネットステータス、カメラ、マイク、空きストレージの読み込み/書き込み</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Huawei Push SDK</p>
                        </td>
                        <td>
                            <p>プッシュ</p>
                        </td>
                        <td>
                            <p>デバイス識別情報</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Xiaomi Push SDK</p>
                        </td>
                        <td>
                            <p>プッシュ</p>
                        </td>
                        <td>
                            <p>デバイス識別情報、デバイス型番、ネットワークタイプ、デバイスストレージ、デバイス実行プロセス情報、アプリVer、SDK Ver</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>OPPO Push SDK</p>
                        </td>
                        <td>
                            <p>プッシュ</p>
                        </td>
                        <td>
                            <p>デバイス識別情報</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>VIVO Push SDK</p>
                        </td>
                        <td>
                            <p>プッシュ</p>
                        </td>
                        <td>
                            <p>デバイス識別情報</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>WeChat SDK</p>
                        </td>
                        <td>
                            <p>WeChat第三者ログイン、WeChat共有</p>
                        </td>
                        <td>
                            <p>デバイス識別情報、ネットワーク情報</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>QQ SDK</p>
                        </td>
                        <td>
                            <p>共有</p>
                        </td>
                        <td>
                            <p>デバイス識別情報、ネットワーク情報</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Weibo SDK</p>
                        </td>
                        <td>
                            <p>Weibo第三者ログイン、Weibo共有</p>
                        </td>
                        <td>
                            <p>デバイス識別情報、ネットワーク情報</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>AppleID SDK</p>
                        </td>
                        <td>
                            <p>Apple IDを使用してログイン</p>
                        </td>
                        <td>
                            <p>Apple ID</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.apple.com/legal/privacy/szh/">https://www.apple.com/legal/privacy/szh/</a></p>
                        </td>
                    </tr>
                </table>
            </div>
                <div className='height'></div>
            
        </div>
    )
}

export default PricacyPolicy